import moment from 'moment';
import { Timestamp } from 'models/firebase';

// eslint-disable-next-line import/prefer-default-export
export const timestampToString = (timestamp: Timestamp): string => {
  const newDate = moment.unix(timestamp.seconds).format('DD/MM/yyyy');
  return newDate;
};

export const timestampToDate = (timestamp: Timestamp): Date => {
  const newDate = moment.unix(timestamp.seconds).format('MM/DD/yyyy');
  return new Date(newDate);
};

export const isSameDay = (date1: Timestamp, date2: Date): boolean => {
  const d1 = timestampToDate(date1);
  const d2 = moment(date2);
  const isSameDate = moment(d1).isSame(d2, 'day');
  return isSameDate;
};
